import styled from "styled-components/macro";

export const Container = styled.div`
  .show-help {
    position: fixed;
    bottom: 25px;
    right: 25px;
    display: block;
    width: 35px;
    height: 35px;
    border-radius: 35px;
    background: var(--grey-0);
    text-align: center;
    line-height: 35px;
    color: var(--menu-color);
    font-size: 20px;
    opacity: 0.7;

    &:hover {
      opacity: 1;
    }
  }

  .history {
    position: fixed;
    bottom: 150px;
    right: 25px;
    display: block;
    width: 36px;
    height: 70px;
    text-align: center;
    line-height: 35px;
    font-size: 25px;
    font-family: Inter;

    .undo,
    .redo {
      background: var(--grey-3);
      color: var(--grey-0);
      display: block;
      opacity: 0.7;

      svg {
        width: 13px;
        height: 13px;
      }

      &:hover {
        opacity: 1;
      }
    }

    .undo {
      border-radius: 18px 18px 0 0;
      height: 34px;
      border-bottom: 1px solid var(--grey-2);

      position: relative;

      svg {
        stroke: var(--grey-0);
        position: relative;
        top: -1px;
      }
    }

    .redo {
      border-radius: 0 0 18px 18px;
      height: 34px;
      position: relative;

      svg {
        stroke: var(--grey-0);
        position: relative;
        top: -4px;
      }

      /* font-size: 14px; */
      /* font-weight: 600; */
      /* line-height: 30px; */
    }
  }

  .zoom {
    position: fixed;
    bottom: 70px;
    right: 25px;
    display: block;
    width: 36px;
    height: 70px;
    text-align: center;
    line-height: 35px;
    font-size: 25px;
    font-family: Inter;

    .in,
    .out {
      background: var(--grey-3);
      color: var(--grey-0);
      display: block;
      opacity: 0.7;

      &:hover {
        opacity: 1;
      }
    }

    .in {
      border-radius: 18px 18px 0 0;
      height: 34px;
      border-bottom: 1px solid var(--grey-2);
    }

    .out {
      border-radius: 0 0 18px 18px;
      height: 34px;
      font-size: 14px;
      font-weight: 600;
      line-height: 30px;
    }
  }
`;
